var _circle, _circle2, _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmittedChecklistLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#E8F5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_633_26330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 220,
    height: 220
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_633_26330)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_26330)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_633_26330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 23,
    width: 223,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.727 23H4V206.52H226.727V23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_633_26330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1885 106.032C33.1885 106.032 40.3051 70.6348 58.2139 70.6348C76.1228 70.6348 85.6481 126.282 42.0882 132.335L33.1885 106.032Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.1885 106.032C33.1885 106.032 40.3051 70.6348 58.2139 70.6348C76.1228 70.6348 85.6481 126.282 42.0882 132.335L33.1885 106.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.645 32.4258H48.2271V178.513H159.645V32.4258Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.462 41.29H59.0117V166.269H148.462V41.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.896 23.645H80.1738V45.5152H128.896V23.645Z",
    fill: "#FF8444"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M121.177 97.3506H99.0762V102.502H121.177V97.3506Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M134.088 107.586H99.0762V112.738H134.088V107.586Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M121.177 130.474H99.0762V135.626H121.177V130.474Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M134.088 140.718H99.0762V145.869H134.088V140.718Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3564 61.3496H70.3906V82.4591H90.3564V61.3496Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3564 94.2827H70.3906V115.392H90.3564V94.2827Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3564 127.216H70.3906V148.326H90.3564V127.216Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1084 71.8753L79.4624 75.5052L84.3423 68.8242",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1084 104.759L79.4624 108.389L84.3423 101.7",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.146 128.738L103.205 134.145L113.106 132.814L123.601 128.779C123.601 128.779 128.973 137.874 137.967 143.265C147.888 149.023 155.507 158.38 159.418 169.609L159.668 170.344V119.906L145.889 104.635L106.146 128.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1084 137.883L79.4624 141.513L84.3423 134.832",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.152 101.898C158.152 101.898 146.906 91.2398 130.256 98.5905C117.219 104.378 123.39 111.183 130.397 110.894C137.404 110.604 149.166 105.553 148.345 117.856C147.602 128.696 134.886 113.11 127.597 113.722C120.308 114.334 121.145 123.09 130.123 127.894C139.101 132.698 151.708 143.1 161.522 134.931C171.337 126.761 168.529 112.25 158.152 101.898Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.025 96.0676L172.563 88.4512L109.647 120.423L113.11 128.039L176.025 96.0676Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.211 137.973L194.587 205.75L226.713 176.752L170.211 118.029L155.211 137.973Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.642 120.428L101.242 129.59L113.106 128.043L109.642 120.428Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2184 92.8442C47.2184 92.8442 61.0449 77.903 67.012 79.226C71.9388 80.3257 71.9467 90.6861 61.2092 99.3185C59.0294 101.051 57.2274 103.259 55.9253 105.793C54.6232 108.327 53.8515 111.127 53.6625 114.003C53.3574 118.824 51.8481 124.562 47.2184 128.886C37.482 137.982 30.2559 130.061 31.1943 117.758C32.1328 105.454 32.7662 101.816 47.2184 92.8442Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.599 126.935L47.3983 202.964L4.77686 194.324L26.2127 118.477L52.599 126.935Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M121.177 63.6729H99.0762V68.8242H121.177V63.6729Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M134.088 73.9092H99.0762V79.0604H134.088V73.9092Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.7646 199.591L40.0006 122.9L52.5994 126.935L47.3987 202.964L30.7646 199.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.211 137.974L162.156 128.738L208.797 192.926L194.587 205.75L155.211 137.974Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_26330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.727,
    height: 183.52,
    fill: "white",
    transform: "translate(4 23)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedChecklistLog);
export default __webpack_public_path__ + "static/media/submitted-checklist-log.8f67d1fcd8f23d8accf651f60c7ee62f.svg";
export { ForwardRef as ReactComponent };